import React from 'react';
import LinkEdinSvg from '../../assets/images/landing/linkedin.svg';
import EnvelopeSvg from '../../assets/images/landing/envelope.svg';
import YoutubeSvg from '../../assets/images/landing/youtube.svg';
import LogoSvg from '../../assets/images/landing/logo.svg';
import logoSm from '../../assets/images/logoSmDark.svg';
import { Link } from 'react-router-dom';

function Footer({ showBookDemo = true }) {
  return (
    <section class="footerSection">
      <div class="footerContentBoxOne">
        {showBookDemo ?
          <div class="footerContentBoxTwo">
            <div class="footerFlexColumnOne">
              <h1 class="footerCallToAction">Ready to get started?</h1>
              <p class="footerHighlightText">Save countless design and development hours with the modern motion workflow.
              </p>
              <Link class="footerBookDemoButton" to={"/book-demo"}>
                Book a demo
              </Link>
            </div>
          </div>
          : null}
      </div>
      <div class="footerContentBoxThree">
        <hr class="footerDivider" size="1" />
        <div class="footerFlexColumnTwo">
          <div class="footerFlexRowOne">
            <div class="footerFlexColumnThree">
              <img src={LogoSvg} />
              <div class="featuresText">
                <p>Adcropper Platform is a useful creative management and automation tool that simplifies ad creation and allows faster and more efficient ad launching.</p>
              </div>
            </div>
            <div class="flex_col">
              <p class="productInfoText">Product</p>
              <div class="featuresText">
                <Link to={"/login"} target="_blank">Sign In</Link>
                <Link to={'/features'}>Features</Link>
                <Link to={"/book-demo"}>Book a demo</Link>
                <Link to={"/privacy"}>Privacy & Policy</Link>
                <Link to={"/terms"}>Terms And Conditions</Link>
              </div>
            </div>

            <div class="flex_col2">
              <p class="socialInfoText">Follow Us</p>
              <div class="socialLink">
                <a href="https://www.linkedin.com/company/adcropper" target="_blank"><img src={LinkEdinSvg} /></a>
                {/* <img src={YoutubeSvg} /> */}
              </div>
              <p class="socialInfoText">Contact Us</p>
              <div class="socialLink">
                <a href="mailto:contact@adcropper.com"><img src={EnvelopeSvg} /></a>
              </div>
            </div>
          </div>
          <hr class="footerDivider" size="1" />
          <p class="footerCopyrightText d-flex align-items-center">© 2024 Adcropper. Crafted with <img src={logoSm} className='mx-1' height='13' /> by Adcropper.</p>
        </div>
      </div>
    </section>
  )
}

export default Footer
